import {Component, HostListener, OnInit} from '@angular/core'
import { CommonModule } from '@angular/common'

@Component({
  selector: 'app-back-to-top',
  templateUrl: './back-to-top.component.html',
  styleUrls: ['./back-to-top.component.scss'],
  standalone: true,
  imports: [ CommonModule ],
})

export class BackToTopComponent implements OnInit {

  show = false

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.showHideButton()
  }

  ngOnInit() {
    this.showHideButton()
  }

  private showHideButton() {
    this.show = window.scrollY > 200 ? true : false
  }

  scrollToTop() {
    (function smoothScroll() {
        const currentScroll = document.documentElement.scrollTop || document.body.scrollTop
        if (currentScroll > 0) {
            window.requestAnimationFrame(smoothScroll)
            window.scrollTo(0, currentScroll - (currentScroll / 6))
        }
    })()
  }

}
